import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DescuentosService {

  url = environment.apiURL + 'descuentos';
  urlPost = environment.baseURL + 'descuentos';
  urlCuponesCarrera = environment.apiURL + 'carrera_cupones';
  urlCuponesCurso = environment.apiURL + 'cursos_cupones';
  options = {headers: {'Authorization':'Bearer '+window.localStorage.getItem('token')}};


  constructor(private http: HttpClient) { }

  insertDescuento(idGrupo, fechaInicio, estado, cupoMinimo, cupoMaximo, horario, fechaDescuento, descuentoSumado, descuentoRestado, categoria): Observable<any> {
    const urlInsert = this.urlPost;
    //return this.http.get<any[]>(url,{headers: {'Authorization':'Bearer TEST-3573383013844763-011811-90ff76a02c0accb4f985532746c07372-468684645'}});
    const token = window.localStorage.getItem('token');
    const data = {
      idGrupo: idGrupo,
      fechaInicio: fechaInicio,
      estado: estado,
      cupoMinimo: cupoMinimo,
      cupoMaximo: cupoMaximo,
      horario: horario,
      fechaDescuento: fechaDescuento,
      descuentoSumado: descuentoSumado,
      descuentoRestado: descuentoRestado,
      categoria: categoria
    };
    return this.http.post<any>(urlInsert, data, {headers: {'Authorization':'Bearer '+token}});
    //'Authorization: Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJyb290IiwiaWF0IjoxNjE0MDQ1MjUzLCJleHAiOjE2MTQwNjMyNTN9.s1_TF1fcSnNZVZ182Wih6eeyvyt3V9SbSpcxV-2lD-Y'
  }

  getDescuentoByIdGroup(id): Observable<any> {
    const urlGet = this.url + '/' + id;
    return this.http.get<any[]>(urlGet);
  }

  deleteDescuento(id): Promise<any> {
    const urlDelete = this.url + '/'  + id;
    return this.http.delete<any>(urlDelete).toPromise();
  }

  getDescuentos(): Observable<any> {
    const url = this.url;
    return this.http.get<any[]>(url);
  }
  getCupnesCurso(): Observable<any> {
    return this.http.get<any[]>(this.urlCuponesCurso, this.options);
  }
  updateCupnesCurso(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'edit_curso',data,this.options);
  }
  updateCupnesCarrera(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCarrera + '/' + 'edit_curso',data,this.options);
  }
  bulkActivateCarrera(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCarrera + '/' + 'active_curso_bulk?active=true&ids=' + data.ids,{},this.options);
  }
  bulkDeactivateCarrera(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCarrera + '/' + 'active_curso_bulk?active=false&ids=' + data.ids,{},this.options);
  }
  bulkActivateCourse(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'active_curso_bulk?active=true&ids=' + data.ids,{},this.options);
  }
  bulkDeactivateCourse(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'active_curso_bulk?active=false&ids=' + data.ids,{},this.options);
  }
  carreraBulk(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCarrera + '/' + 'cupon_curso_bulk?cupon=' + data.cupon + '&ids=' + data.ids,{},this.options);
  }
  cursoBulk(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'cupon_curso_bulk?cupon=' + data.cupon + '&ids=' + data.ids,{},this.options);
  }
  cursosBulkGrupos(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'cupon_grupo_bulk?cupon=' + data.cupon + '&ids=' + data.ids,{},this.options);
  }

  updateCupnesCursoGrupo(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCurso + '/' + 'edit_grupo',data,this.options);
  }
  updateCupnesCarrerasGrupo(data): Observable<any> {
    return this.http.put<any[]>(this.urlCuponesCarrera + '/' + 'edit_grupo',data,this.options);
  }
  getCupnesCarrera(): Observable<any> {
    return this.http.get<any[]>(this.urlCuponesCarrera,this.options);
  }


}
